import { Component } from '@angular/core';

interface FooterLink {
  labelKey: string;
  route: string;
}

interface SocialLink {
  label: string;
  url: string;
  iconClass: string;
}

interface FooterBadge {
  icon: string;
  labelKey: string;
}

interface MobileFooterLink {
  labelKey: string;
  route: string;
  iconClass: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  newsletterMessageKey = '';

  phoneNumber = '01033750675';
  phoneHref = 'tel:+201033750675';

  googleMapsUrl = 'https://maps.app.goo.gl/Yp3V36RCxrBAygFr6?g_st=iw';

  quickLinks: FooterLink[] = [
    { labelKey: 'atw.footer.links.home', route: '/Home' },
    { labelKey: 'atw.footer.links.jobs', route: '/jobs' },
    { labelKey: 'atw.footer.links.iamHiring', route: '/iamhiring' },
    { labelKey: 'atw.footer.links.postJob', route: '/create-job' },
    { labelKey: 'atw.footer.links.about', route: '/about-us' },
    { labelKey: 'atw.footer.links.contact', route: '/contact' },
  ];

  resourceLinks: FooterLink[] = [
    { labelKey: 'atw.footer.links.blog', route: '/blogs' },
    { labelKey: 'atw.footer.links.faqs', route: '/faqs' },
    { labelKey: 'header.policies', route: '/policies' },
    { labelKey: 'header.ourServices', route: '/services' },
  ];

  mobileFooterLinks: MobileFooterLink[] = [
    {
      labelKey: 'atw.footer.links.jobs',
      route: '/jobs',
      iconClass: 'fa-solid fa-briefcase'
    },
    {
      labelKey: 'atw.footer.links.iamHiring',
      route: '/iamhiring',
      iconClass: 'fa-solid fa-building-user'
    }
  ];

  socialLinks: SocialLink[] = [
    {
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/in/ahmed-elshahat-recruitment',
      iconClass: 'fa-brands fa-linkedin-in'
    },
    {
      label: 'Facebook',
      url: 'https://www.facebook.com/share/1Jp8p1fxo9/?mibextid=wwXIfr',
      iconClass: 'fa-brands fa-facebook-f'
    },
    {
      label: 'Instagram',
      url: 'https://www.instagram.com/ahmed.elshahat.recruitment/',
      iconClass: 'fa-brands fa-instagram'
    },
    {
      label: 'Snapchat',
      url: 'https://snapchat.com/t/auXis1Zk',
      iconClass: 'fa-brands fa-snapchat'
    },
    {
      label: 'WhatsApp Channel',
      url: 'https://whatsapp.com/channel/0029Vb6QJXRDDmFRPW6U3F27',
      iconClass: 'fa-brands fa-whatsapp'
    },
    {
      label: 'Google Maps',
      url: 'https://maps.app.goo.gl/Yp3V36RCxrBAygFr6?g_st=iw',
      iconClass: 'fa-solid fa-location-dot'
    },
  ];

  badges: FooterBadge[] = [
    { icon: 'shield', labelKey: 'atw.footer.badges.trusted' },
    { icon: 'people', labelKey: 'atw.footer.badges.human' },
    { icon: 'rocket', labelKey: 'atw.footer.badges.future' },
  ];

  onNewsletterSubmit(event: Event, input: HTMLInputElement): void {
    event.preventDefault();

    const email = input.value.trim();

    if (!email) {
      this.newsletterMessageKey = 'atw.footer.newsletterRequired';
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(email)) {
      this.newsletterMessageKey = 'atw.footer.newsletterInvalid';
      return;
    }

    this.newsletterMessageKey = 'atw.footer.newsletterSuccess';
    input.value = '';
  }
}